import apiClient from '@/api/base'

/**
 * Theme API module - Simplified
 * Gets theme configuration for a specific company
 */
const themeApi = {
  /**
   * Get theme configuration for a specific company
   * @param {string} companyId - The company identifier (e.g., 'svedea')
   * @returns {Promise} Promise that resolves to the company theme or null if not found
   */
  async getCompanyTheme(companyId) {
    try {
      const response = await apiClient.get(`/themes/${companyId}`)
      return response.data
    } catch (error) {
      // Re-throw 404 errors so router can detect invalid companies
      if (error.response?.status === 404) {
        throw error
      }
      // For other errors (network issues, etc.), log and return null for fallback
      console.warn(`Failed to fetch theme for ${companyId} from API:`, error)
      return null
    }
  },
}

export default themeApi
